// extracted by mini-css-extract-plugin
export var actionButton = "_ak-0";
export var attachmentLine = "_ak-1";
export var fileInput = "_ak-2";
export var fileUploadWrapper = "_ak-4";
export var footer = "_ak-3";
export var modalContent = "_ak-5";
export var paperclip = "_ak-6";
export var quillEditor = "_ak-7";